// src/com/session/SecondAuth.js
import React, {useState, useEffect} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TextField, Button } from '@mui/material';
import { AppPalette } from '../../model/AppConst';

const XContainer = styled(Box)({
    display: 'flex', flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
});

const ContentBox = styled(Box)({
    minWidth: 200, width: '60%', maxWidth: 240,
    display: 'inline-flex',
    flexDirection: 'column',
});

const MainTitle = styled(Box)({
    padding:10, fontWeight:'bold', backgroundColor: AppPalette.HeaderBackground, color:'white',
    textAlign:'center', borderTopLeftRadius:20, borderTopRightRadius:20,
    fontSize: '1.2em',
});

const ContentBody = styled(Box)({
    padding:20,
    border: '1px solid ' + AppPalette.HeaderBackground,
    borderBottomLeftRadius:20, borderBottomRightRadius:20,
    display: 'flex', flexDirection: 'column',
    alignItems: 'center',
});

export default function SecondAuth({
    onRequestPost,
    result,
}) {
    const [code, setCode] = useState('');

    const onChangeCode = (e) => {
        setCode(e.target.value);
    };

    return(
        <XContainer>
            <ContentBox>
                <MainTitle>2차 인증</MainTitle>
                <ContentBody>
                    <TextField
                        label="인증 코드"
                        variant="outlined"
                        value={code}
                        onChange={onChangeCode}
                        fullWidth
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onRequestPost(code)}
                        sx={{ marginTop: 2 }}
                        fullWidth
                        disabled={code.length===0 || result.loading}
                    >
                        인증
                    </Button>
                </ContentBody>
            </ContentBox>
        </XContainer>
    );
}
